module.exports = __webpack_public_path__ + "img/new_img4.61d2cdce.png";